import { Dialog, Grid, Typography } from '@mui/material';
import { CancelButtonBlack, SubmitButton } from '@tassat/button';
import * as React from 'react';

import muiStyles from './styles';
import { ActionModalProps } from './types';

const ActionModal: React.FC<ActionModalProps> = (props) => {
    const {
        children,
        headerStyle = 'primary',
        title,
        body,
        open,
        onClose,
        submitButton = { display: 'hidden' },
        cancelButton = { display: 'hidden' }
    } = props;

    const classes = muiStyles(props);
    const headerClasses: {
        border: string;
        title: string;
    } = React.useMemo(() => {
        switch (headerStyle) {
            case 'approve':
                return {
                    border: classes.approvalBorder,
                    title: classes.approvalHeader
                };
            case 'decline':
                return {
                    border: classes.declineBorder,
                    title: classes.declineHeader
                };
            case 'primary':
            default:
                return {
                    border: classes.primaryBorder,
                    title: classes.primaryHeader
                };
        }
    }, [ classes, headerStyle ]);

    const buttonsComponent = React.useMemo(() => {
        if (submitButton.display === 'hidden' && cancelButton.display === 'hidden') {
            return null;
        }

        return (
            <Grid
                alignItems='center'
                container
                direction='column'
                id='ActionModal_ButtonContainer'
                wrap='nowrap'
            >
                {submitButton.display === 'show' && (
                    <SubmitButton
                        onClick={submitButton.onSubmit}
                        text={submitButton.text || ''}
                        type='submit'
                    />
                )}
                {cancelButton.display === 'show' && (
                    <Typography
                        className={classes.cancelButton}
                        onClick={cancelButton.onCancel}
                    >
                        CANCEL
                    </Typography>
                )}
            </Grid>
        );
    }, [ submitButton, cancelButton ]);

    return (
        <Dialog
            classes={{ paperWidthXl: classes.paperWidthXl }}
            maxWidth='xl'
            onClose={onClose}
            open={open}
            transitionDuration={{
                enter: 0,
                exit: 0
            }}
        >
            <Grid
                className={`${classes.root} ${headerClasses.border}`}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    className={classes.cancelIcon}
                    item
                >
                    <CancelButtonBlack onClick={onClose} />
                </Grid>
                <>
                    <Typography
                        className={headerClasses.title}
                        variant='h3'
                    >
                        {title}
                    </Typography>
                </>
                <Grid
                    className={classes.bodyContainer}
                    container
                    direction='column'
                    id='ActionModal_BodyContainer'
                    spacing={0}
                    wrap='nowrap'
                >
                    {body ?
                        <Typography variant='body2'>{body}</Typography>
                        : children}
                    {buttonsComponent}
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default ActionModal;